import { RECEIPT_BONUS_PERCENT } from "./constants";

export function parseReceiptRub(str) {
  const n = parseFloat(String(str).replace(",", ".").replace(/\s/g, ""));
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function previewBonusFromReceiptRub(n) {
  return Math.max(1, Math.round((n * RECEIPT_BONUS_PERCENT) / 100));
}

export function guestDisplayName(user) {
  const parts = [user?.first_name, user?.last_name].filter(Boolean);
  if (parts.length) return parts.join(" ");
  if (user?.username) return `@${user.username}`;
  return "Гость";
}

export function showTelegramAlert(text) {
  const tg = window.Telegram?.WebApp;
  if (tg?.showAlert) {
    tg.showAlert(text);
  } else {
    window.alert(text);
  }
}
